var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import ReactDrawer from "react-drawer";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as authDrawerActions from "../../../actions/authDrawer";
import SignIn from "./SignIn";
import RegisterOne from "./RegisterOne";
import RegisterTwo from "./RegisterTwo";
import RegisterThree from "./RegisterThree";
import ForgotPasswordOne from "./ForgotPasswordOne";
import ForgotPasswordTwo from "./ForgotPasswordTwo";
import ForgotPasswordThree from "./ForgotPasswordThree";
import ForgotPasswordFour from "./ForgotPasswordFour";
import { BREAKPOINT_DOWN_MEDIUM } from "../../../config/constants";
import * as authDrawerConstants from "../../../constants/authDrawer";
import { freezeScroll, thawScroll } from "../../../utils/toggleScroll";

import styles from "./AuthDrawer.css";

var AuthDrawer = function (_Component) {
  _inherits(AuthDrawer, _Component);

  function AuthDrawer() {
    _classCallCheck(this, AuthDrawer);

    var _this = _possibleConstructorReturn(this, (AuthDrawer.__proto__ || Object.getPrototypeOf(AuthDrawer)).call(this));

    _this.onDrawerClose = _this.onDrawerClose.bind(_this);
    _this.state = {
      position: "right",
      mobileDrawer: false
    };
    return _this;
  }

  _createClass(AuthDrawer, [{
    key: "onDrawerClose",
    value: function onDrawerClose() {
      this.props.authDrawerActions.toggleAuthDrawer(false);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Ensure that the drawer opens on the left if screen size is mobile
      if (window.matchMedia(BREAKPOINT_DOWN_MEDIUM).matches) {
        this.setState({
          position: "left",
          mobileDrawer: true
        });
      }

      window.addEventListener("message", function (event) {
        if (event.data && event.data.authToken && event.source.name === authDrawerConstants.FRAME_NAME) {
          _this2.props.authDrawerActions.setAuthToken(event.data.authToken).then(function () {
            // Close the auth drawer when authentication is complete
            _this2.props.authDrawerActions.toggleAuthDrawer(false);
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.authDrawer.authDrawerOpen) {
        freezeScroll();
      } else {
        thawScroll();
      }

      return React.createElement(
        "div",
        { className: styles.root },
        React.createElement(
          ReactDrawer,
          {
            open: this.props.authDrawer.authDrawerOpen,
            onClose: this.onDrawerClose,
            position: this.state.position,
            className: this.state.mobileDrawer ? styles.mobileDrawer : null },
          this.props.authDrawer.step === authDrawerConstants.SIGNIN ? React.createElement(SignIn, null) : null,
          this.props.authDrawer.step === authDrawerConstants.REGISTER1 ? React.createElement(RegisterOne, null) : null,
          this.props.authDrawer.step === authDrawerConstants.REGISTER2 ? React.createElement(RegisterTwo, null) : null,
          this.props.authDrawer.step === authDrawerConstants.REGISTER3 ? React.createElement(RegisterThree, null) : null,
          this.props.authDrawer.step === authDrawerConstants.FORGOTPASSWORD1 ? React.createElement(ForgotPasswordOne, null) : null,
          this.props.authDrawer.step === authDrawerConstants.FORGOTPASSWORD2 ? React.createElement(ForgotPasswordTwo, null) : null,
          this.props.authDrawer.step === authDrawerConstants.FORGOTPASSWORD3 ? React.createElement(ForgotPasswordThree, null) : null,
          this.props.authDrawer.step === authDrawerConstants.FORGOTPASSWORD4 ? React.createElement(ForgotPasswordFour, null) : null
        )
      );
    }
  }]);

  return AuthDrawer;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    authDrawer: state.authDrawer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    authDrawerActions: bindActionCreators(authDrawerActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthDrawer);


// WEBPACK FOOTER //
// ./src/components/Library/AuthDrawer/AuthDrawer.js